import React from 'react';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';
import SolutionList from '../components/solutionList';
import { Breadcrumb } from 'antd';
class Content extends React.PureComponent {
  render() {
    const { dataSource, isMobile,navTitle,routerPage, ...props} = this.props;
    const {
      wrapper,
      titleWrapper,
      page,
      OverPack: overPackData,
      childWrapper,
    } = dataSource;
    return (
      <div {...props} {...wrapper} >
        <div {...page}>
          <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center',}}>
            <div className="text-bold" style={{display: 'flex',justifyContent: 'space-between',alignItems: 'end',}}>
              <h1 className="text-bold-800" style={{fontSize: '36px',}}>{navTitle||'行业动态'}</h1>
              <span style={{marginLeft: '10px', marginBottom:'6px'}}>Industry trends</span></div>
            <div style={{display: 'flex',justifyContent: 'end',alignItems: 'center',}}>
              <div style={{marginRight: '10px',fontSize:"12px"}}>当前位置：</div>
              <Breadcrumb separator=">">
                <Breadcrumb.Item href={'/'}>首页</Breadcrumb.Item>
                <Breadcrumb.Item href={'#/'+routerPage}>{navTitle}</Breadcrumb.Item>
                {/* <Breadcrumb.Item >文章详情</Breadcrumb.Item> */}
              </Breadcrumb>
            </div>
          </div>
          <OverPack {...overPackData}>
            <QueueAnim
              type="bottom"
              key="block"
              leaveReverse
              component={Row}
              componentProps={childWrapper}
            >
              {
                (
                  <div className="detail-content-wrapper">
                    

                  </div>
                )
              }
             
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    );
  }
}

export default Content;
